module.exports = __webpack_public_path__ + "img/lock_image2.7853e81e.svg";